//import React from 'react';
import type { Organism } from '@verndale/core';
import globModules from './glob-modules';
//import { renderElement } from './helpers/react-18-shim';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
/* -- Optional react --
const reactModule = (Component: any, nodeList: NodeListOf<HTMLElement>) => {
  return nodeList.forEach(node => {
    renderElement(<Component {...node.dataset} />, node);
  });
};
*/
const modules: Organism[] = [
  {
    name: 'job-listing',
    loader: () => import('./modules/job-listing')
  },
  {
    name: 'masthead',
    loader: () => import('./modules/masthead')
  },
  {
    name: 'job-overview',
    loader: () => import('./modules/job-overview')
  },
  {
    name: 'avail-jobs',
    loader: () => import('./modules/avail-jobs')
  },
  {
    name: 'overview',
    loader: () => import('./modules/overview')
  },
  {
    name: 'cost-of-living',
    loader: () => import('./modules/cost-of-living')
  },
  {
    name: 'weather',
    loader: () => import('./modules/weather')
  },
  {
    name: 'transportation',
    loader: () => import('./modules/transportation')
  },
  {
    name: 'cta',
    loader: () => import('./modules/cta')
  },
  {
    name: 'attractions',
    loader: () => import('./modules/attractions')
  },
  {
    name: 'state-attractions',
    loader: () => import('./modules/state-attractions')
  },
  {
    name: 'featured',
    loader: () => import('./modules/featured')
  },
  {
    name: 'nearby-cities',
    loader: () => import('./modules/nearby-cities')
  },
  {
    name: 'schools',
    loader: () => import('./modules/schools')
  },
  {
    name: 'community',
    loader: () => import('./modules/community')
  },
  {
    name: 'childcare',
    loader: () => import('./modules/childcare')
  },
  {
    name: 'search-cities',
    loader: () => import('./modules/search-cities')
  },
  {
    name: 'other-cities',
    loader: () => import('./modules/other-cities')
  },
  {
    name: 'table-of-content',
    loader: () => import('./modules/table-of-content')
  }
];

export default [...globModules, ...modules];
